import axios from './_nestAxios'

export const obtener = () => axios.get('/licencias')

export const actualizar = data => axios.put('/licencias', data)

export const validarLicencia = data => axios.post('/licencias/validar-licencia', data)
